module.exports = __webpack_public_path__ + "static/media/flower8.f2fd4599.png";